export default "__VITE_ASSET__Dy8gH2AF__"